<template>
  <section
    id="entry-form"
    class="bg-[#dff0d8] py-20"
  >
    <div class="co-container-sm mx-auto bg-co-gray-50 px-4 py-[3.25rem] shadow md:px-[3.25rem]">
      <h2 class="co-heading-2-caption">
        エントリーフォーム
      </h2>
      <p class="mb-8 text-center">
        下記フォームより必要事項をご記入の上ご応募ください。
        <br class="hidden md:block">
        応募送信後、続けて応募者プロフィールを登録して頂きます。
      </p>
      <div class="alert mb-4 block rounded border-[#ffeeba] bg-[#fff3cd] text-center text-[#856404]">
        <FontAwesomeIcon
          :icon="faTriangleExclamation"
          class="fa-fw inline pr-2"
        />
        現在募集を停止しています
      </div>

      <!-- <TeJobEntryForm :course-name-path="courseNamePath" /> -->
    </div>
  </section>
</template>

<script lang="ts">
import TeJobEntryForm from '~/components/Te/TeJob/TeJobEntryForm.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTriangleExclamation } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    return {
      faTriangleExclamation,
    }
  },
  props: {
    courseNamePath: {
      type: String,
      default: '',
    },
  },
  components: {
    TeJobEntryForm,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>
